import is from './peer/is'
import misc from './peer/misc'
import user from './peer/user'
import common from './peer/common'
import validate from './peer/validate'
import lists from './peer/lists'
import project from './peer/project'

const peer = {
    is, misc, user, common, validate, lists, project
}

export default {
    install(Vue) {
        Vue.prototype.peer = Vue.peer = peer
    }
}
